export default "__VITE_ASSET__18236272__"